import Header from '../440Artists/Header/Header';
import Footer440 from '../440Artists/440Footer/440Footer';

// headerVariant: omit for the landing header; 'full' or 'minimal' for other pages.
// overlayHeader: header floats over the page top (banner and legal pages).
export default function SiteLayout({ headerVariant, overlayHeader = false, mainClassName = '', children }) {
    return (
        <div className="flex min-h-screen w-full flex-col overflow-x-clip bg-[#070038]">
            <Header variant={headerVariant} overlay={overlayHeader} />
            <main className={`flex-1 ${mainClassName}`}>{children}</main>
            <Footer440 />
        </div>
    );
}
